import { GetterTree } from 'vuex'
import { State } from '@/store/global/state'

export type Getters = {
    getIsMobile(state: State): boolean
}

export const getters: GetterTree<State, State> & Getters = {
    getIsMobile (state) {
        return state.isMobile
    }
}